import { Box, Skeleton, useMediaQuery } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import {
  currentGalleryCarIdSet,
  getCurrentGalleryCarId,
} from '../../store/gallery-slice';
import { useDispatch, useSelector } from 'react-redux';

import theme from '../../config/theme';
import { urlParam } from '../../utils/url-param';

export default function ImageListItem({ gallery, mountRef, tab }: any) {
  const currentGalleryCarId: string = useSelector(getCurrentGalleryCarId);

  const dispatch = useDispatch();
  const listRef: any = useRef(null);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));
  const isPortrait = useMediaQuery('(orientation: portrait)');

  useEffect(() => {
    const target = document.querySelector(
      `#image-list-drivee-${tab} #${currentGalleryCarId}`,
    ) as HTMLElement;
    const parent = document.querySelector(`#image-list-drivee-${tab}`)
      ?.parentElement as HTMLElement;

    if (target && parent)
      if (isMobile)
        parent.scrollLeft =
          target.offsetLeft - window.innerWidth / 2 + target.offsetWidth / 2;
      else
        parent.scrollTop =
          target.offsetTop - window.innerHeight / 2 + target.offsetHeight / 2;
  }, [currentGalleryCarId]);

  const [loading, setLoading] = React.useState(
    Array(gallery.length).fill(true),
  );

  const handleClickImage = (imageId: any) => {
    if (imageId === currentGalleryCarId) return;
    dispatch(currentGalleryCarIdSet(imageId));
  };

  useEffect(() => {
    return;
    if (!isMobile) return;
    if (listRef?.current) {
      const navigateTo: any = document.querySelector(
        `#image-list-drivee #${currentGalleryCarId}`,
      );

      navigateTo?.scrollIntoView({ behavior: 'smooth' }, true);
    }
  }, [currentGalleryCarId, isMobile]);

  useEffect(() => {
    return () => {
      mountRef.current = true;
    };
  }, []);

  const handleImageLoad = (index: number) => {
    if (mountRef.current) {
      setLoading(Array(gallery.length).fill(false));
      return;
    }

    setLoading((prevLoading) => {
      const updatedLoading = [...prevLoading];
      updatedLoading[index] = false;
      return updatedLoading;
    });
  };

  const aspect = urlParam('aspect');
  const aspectRatio = aspect ? aspect.split('%3A').join('/') : '16/9';

  return (
    <Box
      sx={{
        flex: '1 1 auto',
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        ref={listRef}
        sx={{
          position: 'relative',
          height: '100%',
          width: isMobile ? '100%' : '400px',
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            display: isPortrait && isMobile ? 'none' : 'block',
          },
          scrollBehavior: 'smooth',
          scrollbarWidth: isPortrait && isMobile ? 'none' : 'block',
          msOverflowStyle: isPortrait && isMobile ? 'none' : 'block',
          willChange: 'transform',
          direction: 'ltr',
          background: '#333',
        }}
      >
        <Box
          id={`image-list-drivee-${tab}`}
          sx={{
            width: isPortrait && isMobile ? 'max-content' : '100%',
            display: !isMobile
              ? 'flex'
              : isPortrait && isMobile
                ? 'flex'
                : 'block',
            flexDirection: isMobile ? 'row' : 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: isPortrait && isMobile ? '100%' : 'max-content',
            [theme.breakpoints.down('lg')]: {
              margin: 'auto',
              padding:
                isPortrait && isMobile ? '0 1rem' : '1rem 1rem 3rem 1rem',
            },
            padding: '1rem',
            gap: '15px',
          }}
        >
          {gallery.map((image: any, index: number) => (
            <React.Fragment key={image?.url}>
              <Skeleton
                sx={{
                  transform: 'none !important',
                  minHeight:
                    isPortrait && isMobile
                      ? '55%'
                      : isMobile
                        ? '100px'
                        : '220px',
                  backgroundColor: '#bbb',
                  borderRadius: 2,
                  boxShadow: '0 0 9px -2px #ddd',
                  display: loading[index] ? 'block' : 'none',
                }}
                width={isPortrait && isMobile ? '140px' : '100%'}
              />

              <picture
                id={image?.id}
                onClick={() => handleClickImage(image?.id)}
                style={{
                  opacity: loading[index] ? 0 : 1,
                  maxWidth: loading[index] ? 0 : '100%',
                  height: 'auto',
                  width: isPortrait && isMobile ? '150px' : '100%',
                  position: 'relative',
                  margin: '0px auto',
                  cursor: 'pointer',
                  transition: '.3s all ease-in-out',
                }}
              >
                <img
                  alt="image"
                  draggable="true"
                  height="auto"
                  loading="lazy"
                  onLoad={() => handleImageLoad(index)}
                  src={image?.url}
                  style={{
                    maxHeight: 'initial',
                    maxWidth: '100%',
                    width: '100%',
                    height: isPortrait && isMobile ? '100%' : 'auto',
                    borderRadius: 8,
                    opacity: currentGalleryCarId === image?.id ? 1 : 0.5,
                    transition: '.3s all ease-in-out',
                    boxShadow:
                      currentGalleryCarId === image?.id
                        ? '0px 0px 0px 3px rgba(0, 144, 237, .4)'
                        : '',
                  }}
                />
              </picture>
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
